/**
 * Jotai Atoms - Global State Management
 * 
 * Replaces Redux with lightweight Jotai atoms
 */

import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { IAdmin, IUser, IGroup, ICrawling } from 'common';

// ============================================================================
// App State
// ============================================================================

export const appLoadedAtom = atom<boolean>(false);
export const appLoadingAtom = atom<boolean>(false);

// ============================================================================
// Admin/Auth State
// ============================================================================

export const adminAtom = atom<IAdmin | null>(null);
export const isAuthenticatedAtom = atom<boolean>(false);
export const authLoadingAtom = atom<boolean>(false);

// Derived atom to check if admin is loaded
export const isAdminLoadedAtom = atom((get) => {
  return get(adminAtom) !== null;
});

// ============================================================================
// Users State
// ============================================================================

export const usersAtom = atom<IUser[]>([]);
export const usersLoadingAtom = atom<boolean>(false);
export const usersTotalAtom = atom<number>(0);
export const usersPageAtom = atom<number>(0);
export const usersSearchAtom = atom<string>('');

// ============================================================================
// Administrators State
// ============================================================================

export const administratorsAtom = atom<Partial<IAdmin>[]>([]);
export const administratorsLoadingAtom = atom<boolean>(false);
export const administratorsTotalAtom = atom<number>(0);
export const administratorsPageAtom = atom<number>(0);
export const administratorsSearchAtom = atom<string>('');

// ============================================================================
// Groups State
// ============================================================================

export const groupsAtom = atom<IGroup[]>([]);
export const groupsLoadingAtom = atom<boolean>(false);
export const groupsTotalAtom = atom<number>(0);
export const groupsPageAtom = atom<number>(0);
export const groupsSearchAtom = atom<string>('');

// ============================================================================
// Crawlings State
// ============================================================================

export const crawlingsAtom = atom<ICrawling[]>([]);
export const crawlingsLoadingAtom = atom<boolean>(false);
export const crawlingsSearchAtom = atom<string>('');

// ============================================================================
// UI State
// ============================================================================

export const sidebarOpenAtom = atomWithStorage<boolean>('sidebar-open', true);
export const alertAtom = atom<{
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
} | null>(null);

// ============================================================================
// Scroll State
// ============================================================================

export const scrollBottomAtom = atom<number>(0);
